'use client';

import { AdvancedMarker, InfoWindow, useAdvancedMarkerRef } from "@vis.gl/react-google-maps";
import { Button, Stack, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import Link from "next/link";
import { Close } from "@mui/icons-material";
import { AuthenticPlace } from "@/app/lib/generated/graphql-types";
import Image from "next/image";
import { mediaRefUrl } from "@/app/features/shared/__to_be_integrated/types/general/media/media-helper";

interface AuthenticPlacesMarkerProps {
    place: AuthenticPlace;
    showExploreButton?: boolean;
    showImage?: boolean;
    showRouteDescription?: boolean;
}

export default function AuthenticPlacesMarker({ place, showImage = false, showExploreButton = false, showRouteDescription = false }: AuthenticPlacesMarkerProps) {
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [infoWindowShown, setInfoWindowShown] = useState(false);

    const placeImageSrc = mediaRefUrl(place.image);

    const onMarkerClick = useCallback(() =>
            setInfoWindowShown(isShown => !isShown),
        []
    );

    const onClose = useCallback(() =>
            setInfoWindowShown(false),
        []
    );

    return (
        <AdvancedMarker
            className="advanced-marker-root"
            ref={markerRef}
            position={place.location!}
            onClick={onMarkerClick}
            title={place.title}
        >
            <Image
                src="/assets/maps/authentic-place-info-marker.png"
                alt=""
                aria-hidden
                width={50}
                height={50}
            />
            {infoWindowShown && (
                <InfoWindow anchor={marker} headerContent={<Typography variant="h4" component="h3">{place.title}</Typography>}>
                    <Stack
                        spacing={2}
                    >
                        {showImage && (
                            <Image
                                src={placeImageSrc}
                                alt={`Bild von ${place.title}`}
                                width={600}
                                height={800}
                                style={{ objectFit: 'cover' }}
                            />
                        )}
                        {showRouteDescription && Boolean(place.routeDescription?.trim()) && (
                            <Typography variant="body1" sx={{ maxWidth: '30vw' }}>{place.routeDescription}</Typography>
                        )}
                    <Stack spacing={2} direction="row" sx={{ width: '100%' }}>
                        {showExploreButton && (
                            <Button
                                component={Link}
                                href={`#${place.documentId}`}
                                variant="contained"
                                sx={{ flexGrow: 1 }}
                            >
                                Entdecken
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={onClose}
                            fullWidth={!showExploreButton}
                            aria-label={`Infofenster zu ${place.title} schließen`}
                        >
                            <Close />
                        </Button>
                    </Stack>
                    </Stack>
                </InfoWindow>
            )}
        </AdvancedMarker>
    )
}
